import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/shop-parts")({
  head: () => pageHead({ title: 'Shop RV Parts', description: 'Shop thousands of RV parts and accessories online at Rex & Sons RVs.', path: '/shop-parts' }),
  beforeLoad: () => {
    throw redirect({ href: "/parts-catalog" });
  },
});
